import React, { useContext, useEffect, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import { NoRecords } from '../../Components/Shimmer';
import { ConfigContext } from '../../Context/ConfigContext';
import Select from 'react-select'
import axios from "axios";
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { currentDateAndTime,decodeData } from '../../Constants/constants';
import { useRowSelect } from 'react-table';
import { useLocation } from 'react-router-dom';

const PublishPayslip = () => {
    const { apiURL, apiHeaderFile, apiHeaderJSON,permissions,setPermissions } = useContext(ConfigContext);
    const locationParams = useLocation();
    const queryParams = new URLSearchParams(locationParams.search);
    const encodedData = queryParams.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
   
    const [rows, setRows] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [loadingPayroll, setLoadingPayroll] = useState(false);
    const [loadingPublish, setLoadingPublish] = useState(false);
    const [loadingAttednace, setLoadingAttednace] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [department, setDepartment] = useState([]);
    const [location, setLocation] = useState([]);
    const [isPublishStatusChanged, setIsPublishStatusChanged] = useState(false);
    // const []
    const [filter, setFilter] = useState({
        keyword: null,
        month: null,
        location: null,
        department: null,
        publishOrUnpublish: "0",
    });
    const [pagination, setPagination] = useState({
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false
    });
    const limitOptions = [10, 25, 50, 100, 200, 500];

    const publishStatusOptions = [
        {
            value: "1",
            label: "Published"
        },
        {
            value: "0",
            label: "Unpublished"
        },
    ]
    const getList = () => {
        const headers = apiHeaderJSON;
        // console.log("filter?.month", filter?.month);
        console.log(" pagination?.page ",  pagination?.page );
        axios
            .get(`${apiURL}Payrolls/GetEmployeesListForPaySlip`, {
                params: {
                    limit: pagination?.limit || 10,
                    page: pagination?.page || 1,
                    keyword: filter?.keyword,
                    monthYear: filter?.month,
                    location_id: filter?.location,
                    department_id: filter?.department,
                    publish_status: filter?.publishOrUnpublish,
                },
                headers,
            })
            .then((response) => {
                var data = response?.data?.data;
                if (data?.success === true) {
                    // console.log(data);
                    setPagination({
                        next: data?.next,
                        prev: data?.prev,
                        page: data?.page,
                        total_records: data?.total_records,
                        total_pages: data?.total_pages,
                        loadingList: false,
                    })
                    setRows(data?.data);

                } else {
                    setPagination({ ...pagination, loadingList: false });
                }
            });
    };

    // useEffect(() => {
    //     if(filter?.keyword){
    //         getList();
    //     }
    // }, [filter?.keyword]);

    const getMonthFilterList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetSalaryRegisterMonthYearFilterData`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                // console.log("getMonthFilterList", data);
                if (data?.success === true) {
                    setMonthOptions(data?.filterData)
                    setFilter({
                        ...filter,
                        month: data?.filterData[0]?.value || null
                    });
                    setIsChanged(true);
                } else {

                }
            });
    };
    const getDepartmentFilterList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetDepartments`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                // console.log("getDepartmentFilterList", data);
                if (data?.success === true) {
                    let row = data?.departments?.map((val) => {
                        return { value: val?.department_id, label: val?.department_title }
                    })
                    // row?.splice(0, 0, { value: "All", label: "All" });
                    // let allDepartmentRow = data?.departments?.map((val) => {
                    //     return val?.department_id
                    // });
                    // allDepartmentRow = allDepartmentRow?.join(",");
                    setDepartment(row)


                } else {

                }
            });
    };
    const getLocationFilterList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetLocations`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                // console.log("getLocationFilterList", data);
                if (data?.success === true) {
                    let row = data?.locations?.map((val) => {
                        return { value: val?.location_id, label: val?.location_title }
                    })
                    setLocation(row);


                } else {

                }
            });
    };
    // useEffect(() => {
    //     if (filter?.month) {
    //         getList();
    //     }
    // }, [filter?.month]);

    useEffect(() => {
        getMonthFilterList();
        getDepartmentFilterList();
        getLocationFilterList();
    }, []);

    const handleMultiSelect = (fieldName, selectedOptions) => {
        const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
        // console.log(ids.join(','))
        setFilter(prevFormData => ({
            ...prevFormData,
            [fieldName]: ids.join(',')
        }));
    };

    const handleSlabChange = (index, fieldName, value) => {
        const updatedRows = [...rows];
        updatedRows[index] = {
            ...updatedRows[index],
            [fieldName]: value,
        };
        setRows(updatedRows);
    };

    const handleAttendance = () => {
        setLoadingAttednace(true);
        const headers = apiHeaderJSON;
        // console.log("filter?.month", filter?.month);
        axios
            .get(`${apiURL}Payrolls/RunAttendaceForPayroll`, {
                params: {
                    month: filter?.month,
                    date: currentDateAndTime(),
                },
                headers,
            })
            .then((response) => {
                var data = response?.data;
                if (data?.success === true) {
                    // console.log(data);
                    Swal.fire({
                        title: `<strong>${data?.success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: data?.success ? 'success' : 'error',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {


                        }
                    });
                    setLoadingAttednace(false);

                } else {
                    Swal.fire({
                        title: `<strong>${data?.success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: data?.success ? 'success' : 'error',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {

                        }
                    });
                    setLoadingAttednace(false);
                }
            }).catch((error) => {
                console.log(error);
                setLoadingAttednace(false);
            })
    };

    const handlePayroll = () => {
        Swal.fire({
            title: `Remark ${ filter?.publishOrUnpublish== "0"? "(Optional)":""}`,
            input: 'text',
            inputPlaceholder: 'Enter your Remark',
            showCancelButton: true,
            confirmButtonText: 'Submit',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                setLoadingPublish(true);
                let data = {
                    monthYear: filter?.month,
                    date: currentDateAndTime(),
                    employees: selectedRows,
                    publish_status: filter?.publishOrUnpublish== "0"? "1":"0",
                }
                if (result.value) {
                    data.remark = result.value;
                } else {
                    data.remark = '';
                }
                const headers = apiHeaderJSON;
                console.log(data);
                axios
                    .post(`${apiURL}Payrolls/PublishPaySlips`, data, {
                        headers,
                    })
                    .then((response) => {
                        const { success } = response.data;
                        // console.log("handlePayroll ~ response =======>>>", response);
                        if (success === true) {
                            Swal.fire({
                                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                text: response.data.message,
                                icon: success ? 'success' : 'error',
                                showConfirmButton: true,  // Show OK button
                                allowOutsideClick: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    // Optional: You can perform any action here after OK is clicked
                                    setSelectedRows([]);
                                    setLoadingPublish(false);
                                    getList();
                                }
                            });

                        } else {
                            Swal.fire({
                                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                text: response.data.message,
                                icon: success ? 'success' : 'error',
                                showConfirmButton: true,  // Show OK button
                                allowOutsideClick: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    // Optional: Action after the OK button is clicked
                                    // setLoadingPublish(false);
                                }
                            });

                        }
                        setLoadingPublish(false);
                    }).catch((e) => {
                        console.log(e);
                        setLoadingPublish(false);
                    });
            }
            else {
                setLoadingPublish(false);
            }
        })
    }

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(rows.map((row) => {
                return { employee_id: row?.employee_id, employee_name: row?.employee_name, employee_code: row?.employee_code }
            }));
        } else {
            setSelectedRows([]);
        }
    };
    const handleInputChange = (e) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value,
        });
        if (!e.target.value) {
            setIsChanged(true);
        }
    };
    const handleCheckboxChange = (employeeData) => {
        const isSelected = selectedRows.some(row => row.employee_id === employeeData?.employee_id);
        if (isSelected) {
            setSelectedRows(selectedRows.filter(row => row.employee_id !== employeeData?.employee_id));
        } else {
            setSelectedRows([...selectedRows, {
                employee_id: employeeData?.employee_id,
                employee_name: employeeData?.employee_name,
                employee_code: employeeData?.employee_code
            }]);
        }
    };

    // useEffect(() => {
    //     console.log("selectedRows", selectedRows);
    // }, [selectedRows]);

    const handleSelectAllDropdown = (action) => {
        if (action === 'select-all') {
            setSelectedRows(rows.map(row => row.employee_id));
        } else if (action === 'deselect-all') {
            setSelectedRows([]);
        }
    };

    const handleInputSearch = (e) => {
        getList();
    }

    const handleClearAll = () => {
        setFilter({
            keyword: null,
            month: monthOptions[0]?.value,
            location: null,
            department: null,
            publishOrUnpublish: "0",
        });
        setIsChanged(true);
    }

    useEffect(() => {
        if (isChanged) {
            console.log(" pagination?.page 1 ",  pagination?.page );
            getList();
            setIsChanged(false);
        }

    }, [isChanged])

    const handlePrev = () => {
        if (pagination?.prev === true) {
            setPagination({
                ...pagination,
                page: pagination?.page - 1
            });
            setIsChanged(true);
        }
    }
    const handleNext = () => {
        if (pagination?.next === true) {
            setPagination({
                ...pagination,
                page: pagination?.page + 1
            });
            setIsChanged(true);
        }
    }
    const handleChanged = (e) => {
        setPagination({
            ...pagination,
            page: parseInt(e.target.value, 10)
        });
        setIsChanged(true);
    }
    const handleLimitChange = (e) => {
        setPagination(
            {
                ...pagination,
                limit: parseInt(e.target.value, 10),
                page: 1,
            }
        );
        setIsChanged(true);
    };
console.log(`(selectedRows?.length === 0) || (!filter?.month) || (filter?.publishOrUnpublish == "1") || (isPublishStatusChanged) || (rows[0]?.paylip_publish_status=="Published")`,(selectedRows?.length === 0) , (!filter?.month) , (filter?.publishOrUnpublish == "1") , (isPublishStatusChanged), (rows[0]?.paylip_publish_status));

    return (
        <div class="main-content" >
            <div class="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Publish Payslip`} primary={`Home`} />

                    <div className="card">
                        {/* <div style={{ width: "60%", margin: "auto" }}>
                            <div className=" position-relative alert alert-danger mt-3" role="alert">
                                This page is under development.
                            </div>
                        </div> */}

                        <div className="card-body">
                            <div className="row mb-3">
                                {/* <div className='col-md-2'>
                                    <label> Select Month </label>
                                    <Select
                                        options={monthOptions}
                                        value={
                                            filter?.month
                                                ? monthOptions.find(option => option.value === filter?.month)
                                                : null
                                        }
                                        onChange={(selectOption) => setFilter({ ...filter, month: selectOption?.value })}
                                        placeholder={`Select Month`} />
                                </div> */}
                                <div className='col-md-3'>
                                    <label htmlFor="keyword">Search By Name</label>
                                    <div className="input-group">
                                        <input type="search" className="form-control" onChange={handleInputChange} name="keyword" value={filter?.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Enter Name" />
                                        <button className="btn btn-success" onClick={handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                                    </div>
                                </div>
                                <div className='col-md-3 position-relative'>
                                    <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                        <label htmlFor="Location" className="form-label" > Select Month </label>
                                        <Select
                                            options={monthOptions}
                                            value={
                                                filter?.month
                                                    ? monthOptions.find(option => option.value === filter?.month)
                                                    : null
                                            }
                                            onChange={(selectOption) => setFilter({ ...filter, month: selectOption?.value })}
                                            placeholder={`Select Month`} />
                                    </div>
                                </div>
                                <div className='col-md-3 position-relative'>
                                    <div style={{ "zIndex": 9, "width": "90%" }} className=' position-absolute'>
                                        <label htmlFor="Location" className="form-label" >Publish Status</label>
                                        <Select
                                            options={publishStatusOptions}
                                            value={
                                                filter?.publishOrUnpublish
                                                    ? publishStatusOptions.find(option => option.value == filter?.publishOrUnpublish)
                                                    : null
                                            }
                                            onChange={(selectOption) => {
                                                if (filter?.publishOrUnpublish=="0"? "1":"0" !== selectOption?.value) {
                                                    setIsPublishStatusChanged(true);
                                                    console.log("setIsPublishStatusChanged", true, filter?.publishOrUnpublish, selectOption?.value);
                                                } else {
                                                    setIsPublishStatusChanged(false);
                                                    console.log("setIsPublishStatusChanged", false);
                                                }
                                                setFilter({ ...filter, publishOrUnpublish: selectOption?.value });
                                            }}
                                            placeholder={`Select Status`} />
                                    </div>
                                </div>
                                {/* <div className="col-md-3 position-relative ">
                                    <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                        <label>Department</label>
                                        <Select
                                            onChange={(selectedOptions) => handleMultiSelect("department", selectedOptions)}
                                            placeholder={"All"}
                                            isMulti
                                            options={department}
                                            // isDisabled={!filter?.month}
                                            value={filter?.department ? filter?.department.split(',').map(id => department.find(option => option.value == id)) : null}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3 position-relative ">
                                    <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                        <label htmlFor="Location" className="form-label" > Location </label>
                                        <Select
                                            onChange={(selectedOptions) => handleMultiSelect("location", selectedOptions)}
                                            placeholder={"All"}
                                            isMulti
                                            options={location}
                                            // isDisabled={!filter?.month}
                                            value={filter?.location ? filter?.location.split(',').map(id => location.find(option => option.value == id)) : null}
                                        />
                                    </div>
                                </div> */}
                                <div className="col-md-3 position-relative" >
                                    <div style={{ "zIndex": 8, "width": "90%" }} className=' position-absolute'>
                                        <label>Department</label>
                                        <Select
                                            onChange={(selectedOptions) => handleMultiSelect("department", selectedOptions)}
                                            placeholder={filter?.month ? "All" : "Select Department"}
                                            isMulti
                                            options={department}
                                            value={filter?.department ? filter?.department.split(',').map(id => department.find(option => option.value == id)) : null}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3 position-relative">
                                    <div style={{ "zIndex": 7, "width": "90%" }} className=' position-absolute'>
                                        <label htmlFor="Location" className="form-label" > Location </label>
                                        <Select
                                            onChange={(selectedOptions) => handleMultiSelect("location", selectedOptions)}
                                            placeholder={filter?.month ? "All" : "Select Location"}
                                            isMulti
                                            options={location}
                                            value={filter?.location ? filter?.location.split(',').map(id => location.find(option => option.value == id)) : null}
                                        />
                                    </div>
                                </div>
                                <div className='col-md-3 d-flex gap-3'>
                                    <div className=''>
                                        <div>
                                            <label>Apply Filter</label>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={() => { setIsPublishStatusChanged(false); setSelectedRows([]); getList() }}
                                            disabled={loadingFilter || loadingPublish}
                                            className={`${(!filter?.department && !filter?.location && !filter?.month && !filter?.publishOrUnpublish) ? 'disabled' : ''}  btn btn-info btn-label waves-effect waves-light noWrap`}>
                                            <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                            {!loadingFilter ? "Filter" : "Loading..."}
                                        </button>
                                    </div>
                                    <div className=''>
                                        <div> <label>Clear Filter</label> </div>
                                        <button type="button"
                                            disabled={loadingFilter || loadingPublish}
                                            className={`btn noWrap btn-secondary btn-label waves-effect waves-light ${(!filter?.department && !filter?.location && !filter?.month && !filter?.publishOrUnpublish) ? 'disabled' : ''}`}
                                            onClick={handleClearAll}
                                        >
                                            <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> Clear</button>
                                    </div>
                                </div>
                            </div>
                            { decodedData?.includes(3) && ( 
                            <div className=' row mb-3'>
                                <div style={{ width: "10%", marginRight: "0.8rem" }} className='col-md-2'>
                                    <div> <label className=' noWrap'>Publish Payslip</label> </div>
                                    {!loadingPublish ?
                                        <button type="button"
                                            disabled={(selectedRows?.length === 0) || (!filter?.month) || (filter?.publishOrUnpublish == "1") || (isPublishStatusChanged) || (rows[0]?.paylip_publish_status=="Published")}
                                            className={`btn noWrap btn-success btn-label waves-effect waves-light ${loadingPublish ? 'disabled' : ''}`}
                                            onClick={handlePayroll}
                                        >
                                            <i className=" ri-file-upload-line label-icon align-middle fs-16 me-2"></i> {!loadingPublish ? "Publish" : "Publishing..."}</button> :
                                        <button className="btn btn-success btn-load">
                                            <span className="d-flex align-items-center">
                                                <span className="spinner-border flex-shrink-0" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </span>
                                                <span className="flex-grow-1 ms-2">
                                                    Processing...
                                                </span>
                                            </span>
                                        </button>
                                    }
                                </div>
                                <div style={{ width: "10%" }} className='col-md-2'>
                                    <div> <label className=' noWrap'>Unpublish Payslip</label> </div>
                                    {(!loadingPublish) ?
                                        <button type="button"
                                            disabled={(selectedRows?.length === 0) || (!filter?.month) || (filter?.publishOrUnpublish == "0") || (isPublishStatusChanged) || (rows[0]?.paylip_publish_status=="Unpublished")}
                                            className={`btn noWrap btn-danger btn-label waves-effect waves-light ${loadingPublish ? 'disabled' : ''}`}
                                            onClick={handlePayroll}
                                        >
                                            <i className=" ri-file-forbid-line label-icon align-middle fs-16 me-2"></i> {!loadingPublish ? "Unpublish" : "Unpublishing..."}</button> :
                                        <button className="btn btn-danger btn-load">
                                            <span className="d-flex align-items-center">
                                                <span className="spinner-border flex-shrink-0" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </span>
                                                <span className="flex-grow-1 ms-2">
                                                    Processing...
                                                </span>
                                            </span>
                                        </button>
                                    }
                                </div>
                            </div>)}
                            <div className="">
                                <div style={{ "maxHeight": "65vh", "overflowY": "auto" }}>
                                    <table className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative" style={{ width: "100%" }}>
                                        <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                            <tr>
                                                {rows?.length > 0 && decodedData?.includes(3)  ?
                                                    <th>
                                                        <div className="d-flex gap-1 align-items-center justify-content-center">
                                                         
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                disabled={loadingPayroll}
                                                                checked={selectedRows.length === rows.length}
                                                                onChange={handleSelectAll}
                                                            />
                                                             Select{" "}
                                                            {selectedRows?.length > 0 && ( <span className="text-white">({selectedRows?.length})
                                                            </span>
                                                            )}
                                                           
                                                        </div>
                                                    </th> : null
                                                }
                                                <th className='noWrap'>Employee Code</th>
                                                <th className='noWrap'>Employee Name</th>
                                                <th>Designation</th>
                                                <th>Department</th>
                                                <th>Location</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        {rows?.length === 0 ?
                                            <tbody>
                                                <td colSpan={5}>
                                                    <NoRecords />
                                                </td>
                                            </tbody> :
                                            <tbody>
                                                {rows?.map((row, idx) => (
                                                    <tr key={row.employee_id}>
                                                        { decodedData?.includes(3) && ( 
                                                        <td>
                                                            <div className="d-flex justify-content-center align-items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    disabled={loadingPayroll}
                                                                    checked={selectedRows.some(val => val.employee_id === row?.employee_id)}
                                                                    onChange={() => handleCheckboxChange(row)}
                                                                />
                                                            </div>
                                                        </td>)}
                                                        <td>{row.employee_code}</td>
                                                        <td>{row.employee_name}</td>
                                                        <td>{row.designation_title}</td>
                                                        <td>{row.department_title}</td>
                                                        <td>{row.location_title}</td>
                                                        <td>{row.paylip_publish_status}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        }

                                    </table>

                                </div>
                                <div className="d-flex bg-light justify-content-between align-items-center w-100 py-2 px-2" >
                                    <button disabled={!pagination?.prev} type="button" onClick={() => handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                    <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                        {
                                            <small>Total Records: {pagination?.total_records} | Total Pages: {pagination?.total_pages} | Current Page: {pagination?.page}</small>
                                        }
                                    </div>
                                    <div className='col-md-2'>
                                        <select className="form-select" onChange={(e) => handleChanged(e)}>
                                            {Array.from({ length: pagination?.total_pages }, (_, i) => (
                                                <option selected={pagination?.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <select className="form-select" onChange={(e) => handleLimitChange(e)} value={pagination?.limit}>
                                            {pagination?.total_records >= 1 && (
                                                <option value={pagination?.total_records}>
                                                    All
                                                </option>
                                            )}
                                            {limitOptions.map((option) => (
                                                <option key={option} value={option}>
                                                    Limit {option}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <button disabled={!pagination?.next} type="button" onClick={() => handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PublishPayslip;
